<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Device</label>
          <v-select
            :options="deviceList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.device"
            @search="searchDevice"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Type</label>
          <v-select
            :options="typeList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.type"
            class="mb-4 md:mb-0"
          />
        </div>

        <div v-show="show_monthly" class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Start Month</label>
          <flat-pickr
            :disabled="filter.type.value !== 'monthly'"
            class="fp"
            :config="config"
            style="width: 100%"
            v-model="filter.month"
          />
        </div>

        <div v-show="show_select_date" class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Start Date</label>
          <flat-pickr
            :config="config_start"
            class="fp"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div v-show="show_select_date" class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">End Date</label>
          <flat-pickr
            :config="config_end"
            class="fp"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button
            :disabled="loading"
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-col w-full mb-base">
      <vx-card title="">
        <vue-apex-charts
          type="line"
          height="350"
          :options="lineChartSimple.chartOptions"
          :series="lineChartSimple.series"
        ></vue-apex-charts>
        <template slot="codeContainer"> </template>
      </vx-card>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import VueApexCharts from 'vue-apexcharts'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default {
  components: {
    flatPickr,
    vSelect,
    VueApexCharts
  },

  data() {
    return {
      lineChartSimple: {
        series: [],
        chartOptions: {
          noData: {
            text: 'No Data'
          },
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: [
            '#468ffb',
            '#5de496',
            '#F3AF1A',
            '#EE4360',
            '#775DD0',
            '#684242'
          ],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Driving Behavior Chart',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: []
          }
        }
      },

      // data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,
      disableDate: true,

      filter: {
        device: '',
        type: '',
        month: '',
        start_time: '',
        end_time: ''
      },

      filtered: {
        device: '',
        type: '',
        month: '',
        start_time: '',
        end_time: ''
      },

      deviceList: [],
      typeList: [
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'select_date', label: 'Select Date' }
      ],

      page: 1,
      per_page: 20,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
      today: '',
      yesterday: '',

      config: {
        dateFormat: 'M Y',
        // maxDate: this.maxDate,
        monthSelectorType: 'dropdown',
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: 'm-Y' //defaults to "F Y"
            // theme: "dark" // defaults to "light"
          })
        ]
      },
      config_start: {
        enableTime: false,
        dateFormat: 'Y-m-d'
      },

      config_end: {
        enableTime: false,
        dateFormat: 'Y-m-d'
      },

      show_monthly: false,
      show_select_date: false
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    filter: {
      handler(val) {
        if (val.type.value == 'monthly') {
          this.show_monthly = true
          this.show_select_date = false
        } else if (val.type.value == 'select_date') {
          this.show_monthly = false
          this.show_select_date = true
        } else {
          this.show_monthly = false
          this.show_select_date = false
        }
      },
      deep: true
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    updatePerPage(n) {
      this.per_page = n
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      }
      if (keyword.length >= 3) {
        this.getDataDevice(keyword)
      } else {
        this.deviceList = []
      }
    },

    getDataDevice(keyword) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.timer = setTimeout(() => {
        this.$http
          .get(
            `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            this.deviceList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }, 1000)
    },

    initTable() {
      this.loading = true
      this.lineChartSimple.chartOptions = {
        ...this.lineChartSimple.chartOptions,
        ...{
          noData: {
            text: 'Loading....'
          }
        }
      }

      this.$http
        .get(`${this.$api.endpoint}/report/driving_behavior/chart`, {
          params: {
            device: this.filter.device ? this.filter.device.value : '',
            type: this.filter.type ? this.filter.type.value : '',
            month: this.filter.month ? this.filter.month : '',
            start_time: this.filter.start_time ? this.filter.start_time : '',
            end_time: this.filter.end_time ? this.filter.end_time : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.lineChartSimple.chartOptions = {
            ...this.lineChartSimple.chartOptions,
            ...{
              noData: {
                text: ''
              }
            }
          }
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          var data = res.data.message.data

          this.lineChartSimple.chartOptions = {
            ...this.lineChartSimple.chartOptions,
            ...{
              xaxis: {
                categories: data.categories
              }
            }
          }

          this.lineChartSimple.series = data.series
        })
        .catch((error) => {
          this.loading = false
          this.lineChartSimple.chartOptions = {
            ...this.lineChartSimple.chartOptions,
            ...{
              noData: {
                text: 'No Data'
              }
            }
          }
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.type = this.filter.type

      this.page = 1
      this.initTable()
    }
  }
}
</script>
